import React, { useState, useEffect } from 'react';
import { Card, SectionHeader, StatCard, NeedProject, RNLLoader } from '../components/UI';
import { useParams, useNavigate } from 'react-router-dom';
import * as api from '../api';

export default function FinanceAnalyticsDashboardPage({ toast }) {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    variationsCount: 0,
    variationsApproved: 0,
    milestonesCount: 0
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!projectId) return;
    const load = async () => {
      setLoading(true);
      try {
        const [vr, mile] = await Promise.all([
          api.listVariations(projectId).catch(() => []),
          api.listProjectMilestones(projectId).catch(() => []),
        ]);
        setStats({
          variationsCount: vr.length,
          variationsApproved: vr.filter(v => v.status === 'approved').length,
          milestonesCount: mile.length
        });
      } catch (e) {}
      setLoading(false);
    };
    load();
  }, [projectId]);

  if (!projectId) return <NeedProject />;

  return (
    <div className="fade-in">
      <SectionHeader title="Finance & Analytics" subtitle="Overview" />
      
      {loading ? (
        <RNLLoader title="Loading Analytics..." subtitle="Please wait" />
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12, marginBottom: 24 }}>
          <StatCard label="Total Variations" value={stats.variationsCount} color="purple" icon="△" />
          <StatCard label="Approved Variations" value={stats.variationsApproved} color="green" icon="✓" />
          <StatCard label="Project Milestones" value={stats.milestonesCount} color="cyan" icon="🚩" />
        </div>
      )}

      {/* DIVIDER */}
      <hr style={{ border: 'none', borderTop: '3px solid #94a3b8', margin: '0 0 32px 0' }} />

      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
        <Card
          className="toggle-on-hover"
          onClick={() => navigate(`/projects/${projectId}/finance/variations`)}
          style={{ width: 280, padding: 24, cursor: 'pointer', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, border: '1px solid black' }}
          onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--accent)'}
          onMouseLeave={e => e.currentTarget.style.borderColor = 'black'}
        >
          <span style={{ fontSize: 32, padding: 12, background: 'var(--accent-dim)', borderRadius: 16 }}>📈</span>
          <span style={{ fontWeight: 700, fontSize: 16 }}>Finance & Variations</span>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Manage variations, QS measurements, and expenses.</span>
        </Card>

        <Card
          className="toggle-on-hover"
          onClick={() => navigate(`/projects/${projectId}/analytics/cost`)}
          style={{ width: 280, padding: 24, cursor: 'pointer', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, border: '1px solid black' }}
          onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--accent)'}
          onMouseLeave={e => e.currentTarget.style.borderColor = 'black'}
        >
          <span style={{ fontSize: 32, padding: 12, background: 'var(--accent-dim)', borderRadius: 16 }}>🔍</span>
          <span style={{ fontWeight: 700, fontSize: 16 }}>Analytics & Reports</span>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>View detailed cost, BOQ, and labour analytics.</span>
        </Card>
      </div>
    </div>
  );
}
